import { clsx, type ClassValue } from 'clsx'
import { createTailwindMerge, getDefaultConfig, mergeConfigs } from 'tailwind-merge'

const num = 40
const sizes = new Array(num).fill(0).map((_, i) => `text-size-${i * 2}`)

const twMerge = createTailwindMerge(() =>
  mergeConfigs(getDefaultConfig(), {
    extend: {
      classGroups: {
        customTextSize: sizes,
      },
      conflictingClassGroups: {
        text: ['customTextSize'],
      },
    },
  })
)

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
